import TYPES from './types';
import CreditCardService from 'src/services/creditCard/CreditCardService';
import AddCreditCardService from 'src/services/creditCard/AddCreditCardService';
import EditOrDeleteCreditCardService from 'src/services/creditCard/EditOrDeleteCreditCardService';
import CreditCardModel from 'src/model/creditCard.model';
import { ICreditCardError } from './reducers';
import { IInvoiceCreditPayment } from 'src/services/invoice/InvoiceService';
import { invoicesActions } from 'src/store/modules/invoices';

const setIsPending = (isPending: boolean) => {
  return {
    type: TYPES.SET_CREDIT_CARD_IS_PENDING,
    payload: isPending ? isPending : false
  };
};

const setError = (error?: ICreditCardError) => {
  return {
    type: TYPES.SET_CREDIT_CARD_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const setSuccess = (success: any = { hasSucceed: false, message: '' }) => {
  return {
    type: TYPES.SET_CREDIT_CARD_SUCCESS,
    payload: success
  };
};

const setSavedCards = (creditCards: CreditCardModel[]) => {
  return {
    type: TYPES.SET_SAVED_CREDIT_CARDS,
    payload: creditCards
  };
};

const setSelectedCard = (creditCard: CreditCardModel) => {
  return {
    type: TYPES.SET_SELECTED_CARD,
    payload: creditCard
  };
};

const getSavedCards = () => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    CreditCardService.getSavedCreditCards()
      .then(response => {
        dispatch(setIsPending(false));
        dispatch(setSavedCards(response));
        if (response.length > 0) {
          dispatch(setSelectedCard(response[0]));
        }
      })
      .catch(err => {
        console.error(err);
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: 'Error getting saved credit cards'
          })
        );
      });
  };
};

const payInvoices = (
  invoicePayments: IInvoiceCreditPayment[],
  creditCardProfile: string,
  props: any
) => (dispatch: any) => {
  dispatch(setIsPending(true));
  dispatch(setError());
  dispatch(setSuccess());
  CreditCardService.payInvoices(invoicePayments, creditCardProfile)
    .then((res: any) => {
      if (res) {
        dispatch(invoicesActions.getInvoices());
        let creditAmount = 0;
        if (invoicePayments && invoicePayments.length > 0) {
          invoicePayments.forEach(ele => {
            creditAmount += ele.paymentAmount;
          });
        }
        props.history.push({
          pathname: '/invoices/payResponse',
          state: {
            orderlistLength: res.data.validationResults.length,
            creditUsed: creditAmount
          }
        });
        dispatch(invoicesActions.clearSelectedInvoices());
        dispatch(setIsPending(false));
      }
    })
    .catch(error => {
      if (error.toString().includes('code 409')) {
        const { data } = error.response;
        if (data) {
          let message = '';
          if (data.message === 'Validation Error') {
            message =
              'Validation Error: Some of the invoices may already be settled.';
            // if (data.validationResults) {
            //   data.validationResults.forEach((validation: any) => {
            //     message += ` - Invoice ${validation.invoiceNumber}: ${validation.message}`;
            //   });
            // }
          } else if (
            data.message === 'Payment Error' ||
            data.message === 'Settlement Error'
          ) {
            message = `${data.detail ? data.detail : ''}`;
          }else{
            message = `${data.message ? data.message : ''}`;
          }
          dispatch(setError({ hasFailed: true, message }));
        }
      } else {
        dispatch(setError({ hasFailed: true, message: error.message }));
      }
      dispatch(setIsPending(false));
    });
};

export default {
  getSavedCards,
  setSelectedCard,
  payInvoices,
  setError,
  setSuccess,
  setIsPending,
  setSavedCards
};
